import { render } from "./BaseItemList.vue?vue&type=template&id=09a9af3e&scoped=true"
import script from "./BaseItemList.vue?vue&type=script&lang=ts"
export * from "./BaseItemList.vue?vue&type=script&lang=ts"

import "./BaseItemList.vue?vue&type=style&index=0&id=09a9af3e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-09a9af3e"

export default script